import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { FrequencyDates, NewsTabs } from 'shared/enums/news';
import { ICreateNews } from 'shared/types/news.types';

const initialState: ICreateNews = {
  created: '',
  title: '',
  data: '',
  author: {
    personnelNumber: '',
    division: '',
    id: 0,
    name: '',
    middleName: '',
    lastName: '',
    position: '',
  },
  users: [],
  retry: FrequencyDates.ONCE,
  isForAllEmployees: true,
  divisions: [],
  organizations: [],
};

export const createNewsSlice = createSlice({
  name: 'news/createNews',
  initialState,
  reducers: {
    clearNews: state => initialState,
    currentNews: (state, { payload }: PayloadAction<ICreateNews>) => payload,
  },
});

const news = (state: RootState) => state.entities.news;
const getOrganizations = createSelector(news, state => state);

export const selectors = { getOrganizations };
export const newsCreateActions = createNewsSlice.actions;
export const reducer = createNewsSlice.reducer;
